import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountDialogService} from "../../../account/services/account-dialogs-service.service";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {$accountFactory} from "../../../account/$account.factory";
import {DepotsAlerts} from "../../services/depots-alerts.service";
import {DepotsService} from "../../services/depots-service.service";
import {BranchesDialogService} from "../../../branches/services/branches-dialogs-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {BranchModel} from "../../../branches/models/branch.model";

export class depotBranchesViewCtrl implements IController {

  depot: any;

  private queryString: any;
  private canRemove: any;

  /* @ngInject */
  constructor(private accountDialogService: AccountDialogService, private depotsService: DepotsService,
              private branchesDialogService: BranchesDialogService, private $log, private IAMPermissions, private depotsAlerts: DepotsAlerts,
              private $account: $accountFactory, private $accounts: $accountsFactory, private confirmDialogService: ConfirmDialogService) {

    this.canRemove = this.IAMPermissions.hasPermission('accounts.demand.update');
  }

  $onInit() {

  }

  onQueryChange(query) {
    this.queryString = query;
    // ctrl.doReload = true;
  }

  onAddBranches(event) {
    this.branchesDialogService.branchesSelect(event, this.depot.branchIds)
      .then((branchIds) => {
        const depotCopy = angular.copy(this.depot);
        if (!depotCopy.branchIds) {
          depotCopy.branchIds = [];
        }
        depotCopy.branchIds = depotCopy.branchIds.concat(branchIds);
        this._updateDepot(depotCopy);
      })
      .catch((err) => {
        this.$log.info('Dialog Closed', err);
      })
  }

  onRemoveFromBranch(branch: BranchModel, event) {
    this.confirmDialogService.confirm('Remove From Branch', 'Are you sure you want to remove this depot from branch?', event)
      .then(() => {
        if (_.get(this.depot, 'branchIds.length')) {
          const depotCopy = angular.copy(this.depot);
          depotCopy.branchIds = _.without(this.depot.branchIds, branch.id);
          this._removeDepot(depotCopy);
        }
      })
  }

  onReloadDepots() {
    // ctrl.doReload = false;
  }

  // ******************************
  //        Private methods
  // ******************************

  private _updateDepot(depot) {
    this.depotsService.updateOne(depot.id, depot)
      .then((updatedDepot) => {
        this.depot = updatedDepot
        // ctrl.doReload = true;
      })
  }

  private _removeDepot(depot) {
    this.depotsService.updateOne(depot.id, depot)
      .then((updatedDepot) => {
        this.depot = updatedDepot
        // ctrl.doReload = true;
      })
  }

}

angular
  .module('bringoz.admin.depots')
  .component('depotBranchesView', {
    bindings: {
      depot: '<'
    },
    template: require('./depot-branches-view.html').default,
    controller: depotBranchesViewCtrl
  });
